<template>
  <div class="cashier-layout">
    <aside class="cashier-sidebar">
      <div class="cashier-logo">
        <i class="el-icon-s-shop"></i>
      </div>
      <ul>
        <li
          v-for="item in menus"
          :key="item.name"
          :class="{active: $route.name === item.name}"
          @click="goPage(item.name)"
        >
          <i :class="item.icon"></i>
          <span>{{ item.title }}</span>
        </li>
      </ul>
      <div class="cashier-user">
        <el-avatar size="medium" :src="circleUrl"></el-avatar>
      </div>
    </aside>
    <section class="cashier-main">
      <main class="cashier-body">
        <router-view></router-view>
      </main>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      circleUrl: this.config.SOURCE_DOMAIN + '/images/head.png',
      menus: [
        {name: 'cashier_index', title: '收银', icon: 'el-icon-s-finance'},
        {name: 'cashier_hold', title: '挂单', icon: 'el-icon-tickets'},
        {name: 'cashier_order', title: '订单', icon: 'el-icon-s-order'},
        {name: 'cashier_verify', title: '核销', icon: 'el-icon-finished'}
      ]
    }
  },
  created() {
    this.getUserInfo()
  },
  methods: {
    goPage(name) {
      if (this.$route.name !== name) {
        this.$router.push({name})
      }
    },
    getUserInfo() {
      this.$api.merchant.myIndex(res => {
        if (res.errcode === 0 && res.data.avatar) {
          this.circleUrl = res.data.avatar
        }
      })
    },
  }
}
</script>

<style scoped>
.cashier-layout {
  min-height: 100vh;
  background: #f5f7fb;
  color: #1f2d3d;
}
.cashier-sidebar {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 76px;
  background: #06213a;
  color: #fff;
  z-index: 20;
}
.cashier-logo {
  height: 74px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
}
.cashier-sidebar ul {
  padding: 0;
  margin: 0;
}
.cashier-sidebar li {
  list-style: none;
  width: 62px;
  height: 68px;
  margin: 0 auto 8px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  color: rgba(255,255,255,.86);
}
.cashier-sidebar li i {
  font-size: 22px;
}
.cashier-sidebar li span {
  font-size: 14px;
}
.cashier-sidebar li.active,
.cashier-sidebar li:hover {
  background: #1688ff;
  color: #fff;
}
.cashier-user {
  position: absolute;
  left: 0;
  bottom: 22px;
  width: 100%;
  text-align: center;
}
.cashier-main {
  margin-left: 76px;
  min-height: 100vh;
}
.cashier-body {
  height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
  padding: 14px;
}
</style>
